export * from './SetAnchorPointIcon';
